<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Akses Menu</h5>
            </template>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter"
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="ml-2 mr-2"
                            v-model="filterNamaMenu" name="filterTable"
                            id="filterInput"
                            type="search"
                            placeholder="Nama Menu"
                            @keyup.enter="onFilter" 
                        ></b-form-input>
                        <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter"> 
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                    </div>
                </b-form-group>
            </div>
            <b-form @submit.prevent="openModalConfirm">
                <div class="custom-table" :style="`max-height: ${window.tableHeight}`">
                    <table v-bind:style="{ opacity: busyOpacity }">
                        <thead>
                            <tr>
                                <th v-for="table in fields" v-bind:key="table.key">
                                    {{table.label}}                                
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="custom-table-template" v-if="isBusy == true">
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>  Loading data...</strong>
                                </div>
                            </tr>
                            <tr class="custom-table-template" v-if="dataMenu.length == 0">
                                <td>
                                    <div>Tidak ada menu</div>
                                </td>
                            </tr>
                            <tr v-for="dataTable of dataMenu">
                             
                                <th class="custom-menu-name">
                                    <div v-if="dataTable.description !=  null">
                                        <p class="mb-0">
                                            {{dataTable.name}} 
                                            <i class="fa fa-info tooltip-trigger-btn ml-1" @click="openModalDetail(dataTable.id)"></i>
                                        </p>
                                    </div>
                                    <p v-else class="mb-0">
                                        {{dataTable.name}}
                                    </p>
                                    <p class="mb-0 smallText text-muted bold-parent">{{dataTable.parent}}</p>
                                </th>
                                <th v-if="dataTable.userSpecificMenu == true" colspan="12"> 
                                    <div class="akses-menu-text">Berdasarkan user pada Parameter > ADMINISTRASI.</div>
                                </th>
                                <th v-else v-for="dataRole in dataTable.roles" v-bind:key="dataRole.id" class="custom-menu-role">  
                                    <b-form-checkbox type="checkbox" v-model="dataRole.selected" @click.native ="kondisi(dataTable.id,dataRole.id,dataRole.selected)"></b-form-checkbox>
                                </th>
                                <!-- <th class="custom-menu-name">
                                    {{ dataTable.id }}
                                    
                                    <p class="mb-0">
                                        {{dataTable.name}}
                                    </p>
                                    <p class="mb-0 smallText text-muted bold-parent">{{dataTable.parent}}</p>
                                </th>
                                <th class="custom-menu-name" v-for="dataRole of dataTable.roles">
                                    {{ dataRole.selected }}
                                    <b-form-checkbox type="checkbox" v-model="dataRole.selected" @click.native ="kondisi(dataRole.id,dataRole.selected)"></b-form-checkbox>
                                </th> -->
        
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="form-wrapper-btn submit-btn-wrapper mb-0">
                    <b-button type="submit" name="updateAksesMenuBtn" variant="pgiBtn">Update</b-button>
                </div>
            </b-form>
        </b-card>
        <ModalConfirm id="modal-confirm-edit" title="Confirm Update Akses Menu" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengubah akses menu ini?" @submit="onSubmit" />
        <b-modal id="modal-detail-informasi" title="Informasi" no-close-on-backdrop hide-footer>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title detail-informasi-title">{{singleDataInformasi.name}} - {{singleDataInformasi.parent}}</h6>
                <span>{{singleDataInformasi.description}}</span>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'master-akses-menu',
    data(){
        return{
            a:[
                {a:false},
                {b:false},
                {c:[
                    {a:true}
                ]},
            ],
            initStatus: 0,
            isBusy: true,
            busyOpacity: 0.55,
            isSubmitting: false,
            fields: [
                { key: "name", label: "Nama Menu"},
            ],
            dataMenu: [],
            dataMenuBaru: [],
            allMenuData: [],
            payload: [],
            window: {
                // width: 0,
                // height: 0,
                tableHeight: 0,
            },
            filterNamaMenu: "",
            singleDataInformasi: {}
        }
    }, 
    
    methods: {

        //----------------- Fungsi Inisialisasi -----------------
        kondisi (menuId,id,val){
            //---------------------- HANYA KONDISI UNTUK LELANG ------------------------
            var LPE = this.dataMenu.findIndex(item => item.id == 602)
            var LSK = this.dataMenu.findIndex(item => item.id == 690)
            var idxLSK = this.dataMenu[LSK].roles.findIndex(item => item.id == id)
            var idxLPE = this.dataMenu[LPE].roles.findIndex(item => item.id == id)
          

            if(menuId == 690 && val == false){
                this.dataMenu[LPE].roles[idxLPE].selected = true;
            }
            if(menuId == 602 && val == true){
                this.dataMenu[LSK].roles[idxLSK].selected = false;
            }        
        },
        init(){
            this.initStatus = 0

            let getAksesMenu = this.$axios.get("akses-menu/").then(response => {
                // this.dataMenu = response.data.menus
                let responseMenus = response.data.menus
                let responseRoles = response.data.roles

                let menus = []
                for(var menu of responseMenus){
                    let roles = []
                        // for respon roles
                        for(var resRoles of responseRoles){
                            let selected = false
                             //cek apakah menu punya akses untuk role
                                if(menu.roles.length!=0){
                                    // jika ada
                                    for(var menurole of menu.roles){
                                        if(resRoles.id == menurole){
                                           selected = true
                                        }
                                    }
                                }
                            resRoles = {
                                id : resRoles.id,
                                selected : selected
                            }
                            roles.push(resRoles)
                        }

                    menu.roles = roles
                    menus.push(menu)
                }
            
                this.dataMenu = menus
                for(var data of this.dataMenuBaru){
                    
                    }

                for (let a=0; a< responseRoles.length; a++){
                    let roleField = []
                    roleField.key = responseRoles[a].id+'-roles'
                    roleField.label = responseRoles[a].name
                    this.fields.push(roleField)
                }

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getAksesMenu]).then(() => {
                this.initStatus = 1
                this.toggleBusy(),
                this.allMenuData = this.dataMenu
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        //----------------- Fungsi Submit Data -----------------

        onSubmit(){
            //----------------- Append Data Akses Menu -----------------
            let payload = []

            for (var x of this.dataMenu) {
                
                let a = {}
                a.menuId = x.id
                a.roleIds = []
                for(let c = 0; c<x.roles.length ; c++){
                    if(x.roles[c].selected == true){
                        a.roleIds.push(x.roles[c].id)
                    }
                }

                payload.push(a)

            }
            //----------------- Submit Semua Data -----------------

            this.isSubmitting = true
            
            this.$axios.post("akses-menu/", payload).then(response => {
                this.$helper.toastSucc(this, `Akses Menu telah berhasil diubah!`)
                this.$bvModal.hide("modal-confirm-edit")
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy(){
            if (this.isBusy == true){
                this.isBusy = false
                this.busyOpacity = 1
            }
            else{
                this.isBusy = true
                this.busyOpacity = 0.55
            }
        },

        openModalConfirm(){
            this.$bvModal.show("modal-confirm-edit")
        },

        handleResize() {
            let windowHeight = window.innerHeight
            let tableHeight = windowHeight - (55+46+50+82+75+48)
            this.window.tableHeight = tableHeight+'px'
        },
        
        onFilter(){
            if(this.filterNamaMenu != ''){
                let arrayCopy = [...this.allMenuData]
                let menuFilter = arrayCopy.filter(item => item.name.toLowerCase().includes(this.filterNamaMenu.toLowerCase()))
                this.dataMenu = menuFilter  
            }else{
                this.dataMenu = this.allMenuData
            }             
        },

        onReset(){
            this.filterNamaMenu = ''
            this.dataMenu = this.allMenuData
        },

        openModalDetail(id){
            let idx = this.dataMenu.findIndex(item => item.id == id);
            this.singleDataInformasi = this.dataMenu[idx]
            this.$bvModal.show("modal-detail-informasi")
        }
    },
    created(){
        this.init()
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
        
    },
}
</script>
